import jwtDecode from 'jwt-decode';

const decodeUserEmail = (token = JSON.parse(localStorage.getItem('token'))) => {
    if (!token) return {};
    return jwtDecode(token).email;
};

const getAuthHeader = () => {
    const token = JSON.parse(localStorage.getItem('token'));
    if (!token) return null;
    return `Bearer ${token}`;
};

const getUsername = () => decodeUserEmail();

export {
    decodeUserEmail,
    getAuthHeader,
    getUsername,
};
